import { Components } from "@mui/material";
import { globalSettings } from "../environments/environments";
import { TypographyOptions } from "@mui/material/styles/createTypography";

export const my_custom_components: Components<any> = {
  MuiTextField: {
    styleOverrides: {
      root: {
        borderRadius: "1rem",
      },
    },
  },
  MuiCard: {
    styleOverrides: {
      root: {
        padding: "0.5rem",
        borderRadius: 30,
        boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px",
      },
    },
  },
  MuiOutlinedInput: {
    styleOverrides: {
      root: {
        borderRadius: "1rem",
        marginBottom: "1rem",
      },
    },
  },
  MuiButton: {
    styleOverrides: {
      // Name of the slot
      root: {
        // Some CSS
        borderRadius: "1rem",
        textTransform: "none",
        textDecoration: "none",
        "&:hover": {
          transform: "scale(1.05)",
          transition: "transform 200ms ease-in-out",
        },
      },
    },
    variants: [],
  },
};

export const my_custom_font_setup: TypographyOptions = {
  fontFamily: [
    globalSettings.fontPrimary,
    "-apple-system",
    "BlinkMacSystemFont",
    '"Segoe UI"',
    "Roboto",
    '"Helvetica Neue"',
    "Arial",
    "sans-serif",
    '"Apple Color Emoji"',
    '"Segoe UI Emoji"',
    '"Segoe UI Symbol"',
  ].join(","),
};
